"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NumberStepperAdapter = exports.NumberStepper = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _NumberStepper = require("../NumberStepper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var NumberStepper = function NumberStepper(_ref) {
  var input = _ref.input,
      atts = _ref.atts,
      meta = _ref.meta,
      label = _ref.label,
      helper = _ref.helper,
      incLabel = _ref.incLabel,
      decLabel = _ref.decLabel,
      incValue = _ref.incValue,
      usePlusMinus = _ref.usePlusMinus,
      light = _ref.light,
      isRequiredField = _ref.isRequiredField,
      cashbotName = _ref.cashbotName,
      formatValue = _ref.formatValue,
      hiddenLabel = _ref.hiddenLabel,
      hiddenHelper = _ref.hiddenHelper,
      prefix = _ref.prefix,
      suffix = _ref.suffix,
      minValue = _ref.minValue,
      maxValue = _ref.maxValue,
      normalizeValue = _ref.normalizeValue,
      ariaPlaceHolder = _ref.ariaPlaceHolder;
  return _react.default.createElement(_NumberStepper.NumberStepper, _extends({}, input, {
    name: input.name,
    value: input.value,
    onChange: input.onChange,
    onBlur: input.onBlur,
    atts: atts,
    label: label,
    helper: helper,
    incLabel: incLabel,
    decLabel: decLabel,
    isRequiredField: isRequiredField,
    cashbotName: cashbotName,
    formatValue: formatValue // This formatting function is used before the value is saved in the redux store
    ,
    isInvalid: meta.invalid,
    isTouched: meta.touched,
    warningMessage: meta.warning,
    errorMessage: meta.error,
    usePlusMinus: usePlusMinus,
    light: light,
    prefix: prefix,
    suffix: suffix,
    incValue: incValue,
    hiddenLabel: hiddenLabel,
    hiddenHelper: hiddenHelper,
    minValue: minValue,
    maxValue: maxValue,
    normalizeValue: normalizeValue,
    ariaPlaceHolder: ariaPlaceHolder
  }));
};

exports.NumberStepper = NumberStepper;
NumberStepper.defaultProps = {
  atts: {
    type: 'tel',
    maxLength: 4
  },
  formatValue: null,
  isRequiredField: true,
  usePlusMinus: false,
  incValue: 1,
  light: false,
  prefix: null,
  suffix: null,
  hiddenLabel: false,
  hiddenHelper: false,
  minValue: 1,
  maxValue: Infinity,
  normalizeValue: null,
  ariaPlaceHolder: ''
};
NumberStepper.propTypes = {
  formatValue: _propTypes.default.func,
  input: _propTypes.default.object.isRequired,
  atts: _propTypes.default.object,
  meta: _propTypes.default.object.isRequired,
  label: _propTypes.default.string.isRequired,
  helper: _propTypes.default.string.isRequired,
  incLabel: _propTypes.default.string.isRequired,
  decLabel: _propTypes.default.string.isRequired,
  isRequiredField: _propTypes.default.bool,
  cashbotName: _propTypes.default.string.isRequired,
  usePlusMinus: _propTypes.default.bool,
  incValue: _propTypes.default.number,
  light: _propTypes.default.bool,
  prefix: _propTypes.default.string,
  suffix: _propTypes.default.string,
  hiddenLabel: _propTypes.default.bool,
  hiddenHelper: _propTypes.default.bool,
  minValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  maxValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  normalizeValue: _propTypes.default.func,
  ariaPlaceHolder: _propTypes.default.string
};
var NumberStepperAdapter = NumberStepper;
exports.NumberStepperAdapter = NumberStepperAdapter;